import React from "react";
import { isLoggedIn } from "./utils/auth";
import { Navigate } from "react-router-dom";

const PrivateRoute = ({ children }) => {
  return isLoggedIn() ? children : <Navigate to="/" />;
};

export default PrivateRoute;
